// ProtectedRoute.jsx
import { useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const [authStatus, setAuthStatus] = useState("checking")
  const location = useLocation()

  useEffect(() => {
    const checkAuth = () => {
      const adminToken = localStorage.getItem("adminToken")
      const userToken = localStorage.getItem("token")
      const userData = localStorage.getItem("user")

      // 🔒 ADMIN ROUTE PROTECTION
      if (adminOnly) {
        if (!adminToken) {
          setAuthStatus("unauthenticated")
          return
        }
        setAuthStatus("authenticated")
        return
      }

      // 👤 USER ROUTE PROTECTION - SIMPLIFIED
      // Just check if we have token and user data
      if (!userToken || !userData) {
        console.log("ProtectedRoute: No token or user data found")
        setAuthStatus("unauthenticated")
        return
      }

      try {
        // Try to parse user data
        const user = JSON.parse(userData)
        
        if (user && (user.id || user.userId)) {
          console.log("ProtectedRoute: User authenticated", user.id || user.userId)
          setAuthStatus("authenticated")
        } else {
          console.log("ProtectedRoute: Invalid user data")
          localStorage.removeItem("token")
          localStorage.removeItem("user")
          localStorage.removeItem("accessTier")
          setAuthStatus("unauthenticated")
        }
      } catch (err) {
        console.error("ProtectedRoute: Error parsing user data:", err)
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("accessTier")
        setAuthStatus("unauthenticated")
      }
    }

    checkAuth()
  }, [adminOnly])

  if (authStatus === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    )
  }
  
  if (authStatus === "unauthenticated") {
    console.log("ProtectedRoute: Redirecting to /auth from", location.pathname)
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />
  }

  return children
}

export default ProtectedRoute